import { render, staticRenderFns } from "./reportdetail.vue?vue&type=template&id=1c974e32&scoped=true"
import script from "./reportdetail.vue?vue&type=script&lang=js"
export * from "./reportdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c974e32",
  null
  
)

export default component.exports